import ReactDOM from 'react-dom/client'
import React from 'react'
import { App } from './App/App'
import { BrowserRouter as Router } from 'react-router-dom'
import './index.css'

const root = ReactDOM.createRoot(document.getElementById('root'))

root.render(
    <Router>
        <App/>
    </Router>
)